<template>
<iframe :style="style" :class="className" :src="src" frameborder="0"></iframe>
</template>

<script>
export default {
  props: {
    ref: String,
    src: String,
    style: String,
    className: String,
    alt: String
  }
}
</script>

<style lang="scss" scoped>
.c-iframe {
  width: 100%;

  &__fv {
    background: #fff;
    position: relative;

    &--sp {
      @extend .c-iframe__fv;
      width: 375px;
      height: 812px;
      transform-origin: left top;
    }
    &--pc {
      @extend .c-iframe__fv;
      width: 1280px;
      height: 882px;
      transform-origin: left top;
    }
  }
}
</style>
